export default IconConePlus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-cone-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18.03 12.022l-5.16 -9.515a1 1 0 0 0 -1.74 0l-8.13 14.99v.5c0 1.66 4.03 3.003 9 3.003c.17 0 .34 -.002 .508 -.005" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;